// The "Privacy" link in the line under the page (2.1.3).
//
// Up to 2.1.2 public/index.html linked https://suite-preview.electionadminsuite.com/privacy.html on
// every copy, so the live tracker pointed people at the suite's test site. The privacy notice is
// the suite's (accounts/site/privacy.html in freddie4tuesday/election-admin-suite), and the suite
// has no live site yet, so there is no production address to link. Now the link is shown only
// where the Worker names a suite address (suiteOrigin, from SUITE_URL: staging and local tests)
// and points at that suite's own copy. Production leaves SUITE_URL unset, so the line says what is
// counted and has no link until the suite goes live (then setting SUITE_URL brings it back).
import { suiteOriginOf } from "../worker/src/suiteOrigin.js";

export function privacyHref(suiteOrigin) {
  const o = suiteOriginOf(suiteOrigin);
  return o ? `${o}/privacy.html` : null;
}

// Shows or hides the link in public/index.html. Called with every answer that carries suiteOrigin
// (signed in, signed out, no office); an answer without one leaves it hidden.
export function showPrivacyLink(suiteOrigin, doc = typeof document !== "undefined" ? document : null) {
  const a = doc && doc.getElementById("privacy-link");
  if (!a) return;
  const href = privacyHref(suiteOrigin);
  if (href) {
    a.setAttribute("href", href);
    a.hidden = false;
  } else {
    a.removeAttribute("href");
    a.hidden = true;
  }
}
